/* global google */

let initialized = false
let pendingCallback = null

export const GOOGLE_IDENTITY_SERVICES_LOCALE = 'en'
export const GOOGLE_IDENTITY_SERVICES_SCRIPT_SRC = `https://accounts.google.com/gsi/client?hl=${GOOGLE_IDENTITY_SERVICES_LOCALE}`

export function getGoogleClientId() {
  return process.env.GOOGLE_CLIENT_ID || ''
}

export function isGoogleIdentityServicesReady() {
  return (
    typeof google !== 'undefined' &&
    !!google?.accounts?.id &&
    !!getGoogleClientId()
  )
}

export function waitForGoogleIdentityServices(timeoutMs = 10000) {
  return new Promise((resolve) => {
    if (!getGoogleClientId()) {
      resolve(false)
      return
    }
    if (isGoogleIdentityServicesReady()) {
      resolve(true)
      return
    }

    const startedAt = Date.now()
    const intervalId = window.setInterval(() => {
      if (isGoogleIdentityServicesReady()) {
        window.clearInterval(intervalId)
        resolve(true)
        return
      }
      if (Date.now() - startedAt >= timeoutMs) {
        window.clearInterval(intervalId)
        resolve(false)
      }
    }, 100)
  })
}

export function initializeGoogleIdentityServices(onCredential) {
  if (!isGoogleIdentityServicesReady() && !getGoogleClientId()) return false
  if (!google?.accounts?.id) return false

  pendingCallback = onCredential
  if (initialized) return true

  google.accounts.id.initialize({
    client_id: getGoogleClientId(),
    callback: (response) => {
      if (pendingCallback && response?.credential) {
        pendingCallback(response.credential)
      }
    },
    cancel_on_tap_outside: false,
    context: 'signin',
    // FedCM account chooser (centered modal on button click — Chrome M125+).
    use_fedcm_for_button: true,
  })
  initialized = true
  return true
}

export function renderGoogleButton(element, options = {}) {
  if (!element || !getGoogleClientId()) return false
  if (!google?.accounts?.id) return false

  initializeGoogleIdentityServices(options.onCredential)

  element.innerHTML = ''
  const measuredWidth = element.offsetWidth
  const width =
    typeof options.buttonOptions?.width === 'number'
      ? options.buttonOptions.width
      : measuredWidth > 0
        ? Math.min(measuredWidth, 400)
        : undefined

  google.accounts.id.renderButton(element, {
    type: 'standard',
    theme: 'outline',
    size: 'large',
    shape: 'rectangular',
    text: 'continue_with',
    locale: GOOGLE_IDENTITY_SERVICES_LOCALE,
    width,
    ...options.buttonOptions,
  })
  return true
}

export function promptGoogleOneTap(onCredential, onNotification) {
  if (!getGoogleClientId() || !google?.accounts?.id) return false

  initializeGoogleIdentityServices(onCredential)
  google.accounts.id.prompt(onNotification)
  return true
}
